import * as m from '../../../localization/out/messages.js';

/**
 * Returns the appropriate matching score text based on a numeric score
 * @param score Numeric score (0-100)
 * @returns Localized text describing the matching level
 */
export const getMatchingScoreText = (score: number) => {
  const scoreClass = score >= 70 ? 'badge-success' : score >= 40 ? 'badge-warning' : 'badge-error';
  
  switch (scoreClass) {
    case 'badge-success':
      return m.fit_good();
    case 'badge-warning':
      return m.fit_medium();
    case 'badge-error':
      return m.fit_low();
    default:
      return '?';
  }
};
